import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { useIntl } from "gatsby-plugin-intl"
import Seo from "../components/Seo"

import DefaultLayout from "../layouts/default"
import CampusTitle from "../components/sections/Title"
import About from "../components/sections/About"

const CampusContent = styled.div`
  padding: 0 0 6rem;
`

const Benguerir = () => {
  const { formatMessage } = useIntl()
  const {
    image: {
      childImageSharp: { fixed },
    },
    cluster,
    playground,
    meetings,
    findUs,
  } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "benguerir/banner.jpeg" }) {
        childImageSharp {
          fixed(width: 1920) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      cluster: file(relativePath: { eq: "benguerir/cluster.jpeg" }) {
        childImageSharp {
          fixed(quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      playground: file(relativePath: { eq: "benguerir/playground.jpg" }) {
        childImageSharp {
          fixed(quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      meetings: file(relativePath: { eq: "benguerir/meetings.jpeg" }) {
        childImageSharp {
          fixed(quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      findUs: file(relativePath: { eq: "benguerir/findUs.jpg" }) {
        childImageSharp {
          fixed(quality: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <DefaultLayout>
      <CampusContent>
        <Seo
          title={formatMessage({
            id: "sections.campus.benguerir.header.title",
          })}
        />
        <CampusTitle
          title={formatMessage({
            id: "sections.campus.benguerir.header.title",
          })}
          fixed={fixed}
        >
          {formatMessage({ id: "sections.campus.benguerir.header.paragraph" })
            .split("\n")
            .map((paragraph, key) => (
              <p key={key}>{paragraph}</p>
            ))}
        </CampusTitle>
        <About
          fixed={cluster.childImageSharp.fixed}
          title={formatMessage({
            id: "sections.campus.benguerir.sections.cluster.title",
          })}
          paragraph={formatMessage({
            id: "sections.campus.benguerir.sections.cluster.paragraph",
          })}
        />
        <About
          fixed={playground.childImageSharp.fixed}
          reverse
          title={formatMessage({
            id: "sections.campus.benguerir.sections.playground.title",
          })}
          paragraph={formatMessage({
            id: "sections.campus.benguerir.sections.playground.paragraph",
          })}
        />
        <About
          fixed={meetings.childImageSharp.fixed}
          title={formatMessage({
            id: "sections.campus.benguerir.sections.meetings.title",
          })}
          paragraph={formatMessage({
            id: "sections.campus.benguerir.sections.meetings.paragraph",
          })}
        />
        <About
          fixed={findUs.childImageSharp.fixed}
          reverse
          title={formatMessage({
            id: "sections.campus.benguerir.sections.findUs.title",
          })}
          paragraph={formatMessage({
            id: "sections.campus.benguerir.sections.findUs.paragraph",
          })}
        />
      </CampusContent>
    </DefaultLayout>
  )
}

export default Benguerir
